// OFRA fertilizer calculator options.
//
// Each option keeps the display label separate from the numeric value so the
// UI can stay fully translatable while the calculation uses stable internal
// numbers.

export const OFRA_VOLUME_CONTAINER_OPTIONS = [
  {
    value: "faro_water_bottle_lid",
    label: "ofra.volumeContainers.faroWaterBottleLid",
    volumeMl: 9,
  },
  {
    value: "gino_tomato_sauce_can",
    label: "ofra.volumeContainers.ginoTomatoSauceCan",
    volumeMl: 70,
  },
  {
    value: "peak_milk_can",
    label: "ofra.volumeContainers.peakMilkCan",
    volumeMl: 180,
  },
];

export const OFRA_FERTILIZER_TYPE_OPTIONS = [
  {
    value: "urea",
    label: "ofra.fertilizerTypes.urea",
    densityGPerMl: 1.32,
  },
  {
    value: "single_super_phosphate",
    label: "ofra.fertilizerTypes.singleSuperPhosphate",
    densityGPerMl: 2.22,
  },
  {
    value: "muriate_of_potash",
    label: "ofra.fertilizerTypes.muriateOfPotash",
    densityGPerMl: 1.98,
  },
  {
    value: "zinc_sulphate",
    label: "ofra.fertilizerTypes.zincSulphate",
    densityGPerMl: 3.54,
  },
  {
    value: "npk_15_15_15",
    label: "ofra.fertilizerTypes.npk151515",
    densityGPerMl: 1,
  },
  {
    value: "npk_20_10_10",
    label: "ofra.fertilizerTypes.npk201010",
    densityGPerMl: 1.2,
  },
];

export const OFRA_APPLICATION_METHOD_OPTIONS = [
  {
    value: "point",
    label: "ofra.applicationMethods.point",
    spacingLabel: "ofra.rowSpacing",
    spacingValue: 0.75,
    secondaryLabel: "ofra.pointSpacing",
    secondaryValue: 0.25,
    resultLabel: "ofra.pointsPerContainer",
  },
  {
    value: "band",
    label: "ofra.applicationMethods.band",
    spacingLabel: "ofra.rowSpacing",
    spacingValue: 0.75,
    secondaryLabel: "ofra.bandWidth",
    secondaryValue: 0.25,
    resultLabel: "ofra.metersPerContainer",
  },
  {
    value: "broadcast",
    label: "ofra.applicationMethods.broadcast",
    spacingLabel: "ofra.applicationWidth",
    spacingValue: 0.75,
    secondaryLabel: "ofra.widthFactor",
    secondaryValue: 0.25,
    resultLabel: "ofra.metersPerContainer",
  },
];
